import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PlaceModel } from './place.model';
import { AbstractService } from '../services/abstract.service';

@Injectable({
    providedIn: 'root'
})
export class PlaceService extends AbstractService<PlaceModel> {
    constructor(http: HttpClient) {
        super(http, '/places', PlaceModel);
    }
}
